<template>
  <main class="recruit recruit2">
<script type="application/ld+json">
{
  "@context" : "https://schema.org/",
  "@type" : "JobPosting",
  "title" : "職人（精密板金加工）",
  "description" : "<p>ものづくりこそ自分の天職とお考えの方。精密板金加工でその力を発揮してください。</p>",
  "identifier": { 
    "@type": "PropertyValue",
    "name": "豊嶋精密工業株式会社",
    "value": "1"
	},
  "datePosted" : "2023-08-15",
  "employmentType" : "FULL_TIME",  
	"hiringOrganization" : {
    "@type" : "Organization",
    "name" : "豊嶋精密工業株式会社",
    "sameAs" : "https://toyoshimaseimitsu.co.jp",
    "logo" : "https://toyoshimaseimitsu.co.jp/asset/images/logo.png"
  },
	"jobLocation": {
		"@type": "Place",
    "address": [{
    "@type": "PostalAddress",
    "streetAddress": "5-24-8",
    "addressLocality": "品川区西五反田",
    "addressRegion": "東京都",
    "postalCode": "141-0031", 
		"addressCountry": "日本"
    }, {
    "@type": "PostalAddress",
    "streetAddress": "4-7-2",
    "addressLocality": "大田区城南島",
    "addressRegion": "東京都",
    "postalCode": "141-0031", 
		"addressCountry": "日本"
    }]
  },
 "baseSalary": {
    "@type": "MonetaryAmount",
    "currency": "JPY",
    "value": {
      "@type": "QuantitativeValue",
      "value": 200000,
			"minValue": 200000,
			"maxValue": 350000,
      "unitText": "MONTH"
		}
  }
}
</script>
<script type="application/ld+json">
{
	"@context": "http://schema.org",
	"@type": "VideoObject",
	"name": "精密板金加工業 職人・軽作業スタッフ採用求人イメージ",
	"description": "豊嶋精密工業株式会社 精密板金加工業 職人・軽作業スタッフ 採用求人ページ オープニングイメージ",
	"thumbnailUrl": "https://toyoshimaseimitsu.co.jp/asset/images/pages/recruit/ai_thumbnail.png",
	"uploadDate": "2025-07-20T08:00:00+09:00",
	"duration": "PT10S",
	"contentUrl": "https://toyoshimaseimitsu.co.jp/asset/images/pages/recruit/ai.mp4"
}
</script>
    <div class="container">
      <div class="blockView">
				<video autoplay muted poster="/asset/images/pages/recruit/ai_thumbnail.png">
<source src="/asset/images/pages/recruit/ai.mp4" type="video/mp4" />
				</video>
        <h1><span>採</span><span>用</span><span>情</span><span>報</span></h1>
				<p class="">
<span @click="smoothScroll('RecruitRequirements')" class="anchorLink">豊嶋精密工業では未来を継ぐ人材を求めています。</span>
				</p>
			</div>
		</div>

    <section class="tagJumpTarget" id="RecruitRequirements">
      <div class="areaH2">
        <h2>募集要項</h2>
      </div>
		   <div class="rowView">

					<dl v-for="(j, resetIndexKey) in originListRecruit" :key="resetIndexKey" tabindex="0">
<dt>{{j.title}}</dt>
<dd v-html="replaceBr(j.content)"></dd>
					</dl>
<!--
				<dl>
<dt>募集職種</dt>
<dd>職人</dd>
				</dl>
				<dl>
<dt>募集対象</dt>
<dd>40歳以下(長期キャリア形成を図るため)</dd>
				</dl>
				<dl>
<dt>勤務地</dt>
<dd>本社工場（東京都品川区西五反田5丁目）、城南島工場（東京都大田区城南島4丁目）</dd>
				</dl>
				<dl>
<dt>給与</dt>
<dd>200,000～350,000円（経験に応じて）</dd>
				</dl>
				<dl>
<dt>諸手当</dt>
<dd>通勤手当/役職手当 他</dd>
				</dl>
				<dl>
<dt>勤務時間</dt>
<dd>本社工場 8:20～17:20、城南島工場 8:40～17:25</dd>
				</dl>
				<dl>
<dt>休日休暇</dt>
<dd>週休2日制、夏期休暇、年末年始休暇、年間休日約115日</dd>
				</dl>
				<dl>
<dt>福利厚生</dt>
<dd>各種社会保険完備/退職共済制度/他</dd>
				</dl>
				<dl>
<dt>応募方法</dt>
<dd>履歴書と職務経歴書をメールまたは郵送でお送りください。</dd>
				</dl>
				<dl>
<dt>資料請求先</dt>
<dd>【 人事部 】<br>
〒141-0031 <span class="brSp"></span>東京都品川区西五反田5-24-8<br>
TEL. 03-3491-8624<br>
FAX. 03-3491-8625<br>
E-mail. toyoshima.precision.industry@gmail.com<br>
豊嶋宛
</dd>
				</dl>
-->
      </div>
    </section>

    <section class="tagJumpTarget myCompany" id="RecruitInsideCompany"><!-- v-show="!signIn">-->
      <div class="areaH2">
        <h2>応募をお考えの方へ</h2>
      </div>
      <div class="container">

				<div class="rowView">
					<div  class="_image" v-scroll:[activeFlg]='handleScrollChild'>
<img-plus :img-src="'pages/recruit/TP-45_trim.png'" :img-alt="'古い機械'" class="fromBottom" />
<!--<img src="asset/images/recruit/TP-45_trim.png" alt="古い機械" class="fromBottom" v-scroll:[activeFlg]='handleScrollChild' />-->
					</div>
					<div class="_block">
						<p class="">
豊嶋精密工業株式会社(旧福智製作所)は1959年から続く金属板金加工会社です。現在の代表は3代目です。<br>
社員は20代の若手から70代の熟練の職人まで、幅広い世代が働いています。
						</p>
					</div>
					<div  class="_image" v-scroll:[activeFlg]='handleScrollChild'>
<img-plus :img-src="'pages/recruit/DSC_2536_trim.png'" :img-alt="'作業着'" class="fromBottom" /><!-- :img-width="'680'" :img-height="'380'" />-->
					</div>
				</div>

				<div class="rowView tagJumpTarget" id="RecruitWorkplace">
						<div  class="_image _arrange" v-scroll:[activeFlg]='handleScrollChild'>
<img-plus :img-src="'pages/recruit/honsya.png'" :img-alt="'本社工場 中の様子'" :full-screen="true" class="fromBottom"/>
						</div>
						<div class="_block">
							<h3>勤務場所について</h3>
							<p>
2023年現在、本社工場（品川区西五反田）城南島工場（大田区城南島）の体制で製作しています。<br>
本社工場は、創業当時から稼働している味わい深い古い工場、城南島工場は2007年から稼働して広々とした工場です。<br>
どちらかに常駐して作業するのではなく、製造内容により行き来します。
							</p>
						</div>
						<div  class="_image" v-scroll:[activeFlg]='handleScrollChild'>
<img-plus :img-src="'pages/recruit/IMG_1632.jpg'" :img-alt="'城南島工場 中の様子'" :full-screen="true" class="fromBottom"/>
						</div>
					</div>

					<div class="rowView tagJumpTarget" id="RecruitHope">
						<div  class="_image" v-scroll:[activeFlg]='handleScrollChild'>
<img-plus :img-src="'pages/recruit/DSC_2513.png'" :img-alt="'製作作業'" class="fromBottom" />
						</div>
						<div class="_block">
							<h3>会社があなたに求めること</h3>
							<p>
募集している職人という職種はイメージされる手先の器用さだけでなく、現代では機械をうまく操ることも求められます。<br>
資質と努力で多くの業務/工程で練度を高めていただき、そこから生じるアイデアにより、難題をクリアできるようになっていただけることを期待しています。
							</p>
						</div>
						<div  class="_image _portrait" v-scroll:[activeFlg]='handleScrollChild'>
<img-plus :img-src="'pages/recruit/DSC_2526.jpg'" :img-alt="'製作作業'" class="fromBottom" />
						</div>
					</div>

					<div class="rowView tagJumpTarget" id="RecruitGrowth">
						<div  class="_image" v-scroll:[activeFlg]='handleScrollChild'>
<img-plus :img-src="'pages/recruit/DSC_2532.jpg'" :img-alt="'製作機械'" class="fromBottom" />
						</div>
						<div class="_block">
							<h3>あなたと会社の成長</h3>
							<p>
業務では学ばなくてはならない技術知識は数多くあります。<br>
未経験、工業高校/専門卒、同業からの転職など、応募される方のスタートラインに違いはありますが、興味と探究心で道を究め、職人となっていただきたいと思います。
<br>
会社もあなたの成長に報えるよう、チャレンジ精神と成長努力を怠らず邁進していきます。
							</p>
						</div>
						<div  class="_image" v-scroll:[activeFlg]='handleScrollChild'>
<img-plus :img-src="'pages/recruit/DSC_2514.jpg'" :img-alt="'製作ソフトウェア'" class="fromBottom" />
						</div>
					</div>

					<div class="rowView tagJumpTarget" id="RecruitAchieve">
						<div  class="_image _portrait" v-scroll:[activeFlg]='handleScrollChild'>
<img-plus :img-src="'pages/recruit/DSC_2539.jpg'" :img-alt="'製作品'" class="fromBottom" />
						</div>
						<div class="_block">
							<h3>ものつくりで得られるもの</h3>
							<p>
必要なものを使える形にする、この難しい課題は人の技巧のみで成し遂げられます。<br>
ものを形にし世に送り出す仕事から得られる達成感は、前に進む原動力となります。これは、あなたと会社さらには社会全体に良い影響をもたらすものと思っています。<br>
<br>
業務におけるこのような蓄積が、あなたの人生を育む一部となれることを期待します。
							</p>
						</div>
						<div  class="_image" v-scroll:[activeFlg]='handleScrollChild'>
<img-plus :img-src="'pages/recruit/DSC_2366.jpg'" :img-alt="'製作品 大'" class="fromBottom" />
						</div>
					</div>

      </div>
    </section>

		<section class="tips">
			<div class="container">
				<div class="rowView">
					<div class="noteContent marginTop3em marginBottom3em">
						<p class="">
ご不明な点、気になることなど、お気軽にお問い合わせください。
						</p>
					</div>
<router-link class="pageLinkButton marginBottom2em" to="/customer/contact" >問い合わせフォーム</router-link>
				</div>
			</div>
		</section>

  </main>
</template>

<script>
//imgPlus > impPlusStaticへ
import imgPlus from '@/components/ImgPlusStatic.vue'

let activeFlg = true

export default {
  name: 'recruit2',
  components:{
    imgPlus,
  },
  data() {
    return {
			pageTitle:"採用情報",
			description:"豊嶋精密工業株式会社の従業員募集要項です",
			keywords:"求人 職人",
			ogType:"article",
      activeFlg:true,
      originListRecruit:[],
		}
	},
  computed: {
    signIn:function() {
      return !this.$store.getters.idToken
    },
	},
  created:function() {this._log("created "+this.$options.name)},
  beforeMount:function() {this._log("beforeMount "+this.$options.name)
		this.setRecruit()
	},
  mounted: function() {this._log("mounted "+this.$options.name)

    this.$store.commit('updatePageSectionInfo', this.gatherTagId())
    this.$store.commit('updatePageBackgroundStyle', '')

/*head情報をセットする*/
    this.$store.commit('updateCurrentTitle', this.pageTitle)
    this.$store.commit('updateCurrentDescription', this.description)
    this.$store.commit('updateCurrentKeywords', this.keywords)
    this.$store.commit('updateCurrentOgUrl', this.isUrl)
    this.$store.commit('updateCurrentOgType', this.ogType)
    this.$store.commit('updateCurrentOgDesc', this.description)
    this.$store.commit('updateLinkCanonical', '')
		this.$store.commit('updateLdJsonBreadcrumb', this.makeBreadcrumbList())

//directive処理のセットトリガーが、updated時なので、以下を発行して強制的にupdatedまで遷移する
		this.$forceUpdate()
  },
  updated: function() {this._log("updated "+this.$options.name)
//    this.$store.commit('updatePageSectionInfo', this.gatherTagId())
 //   this.$store.commit('updatePageBackgroundStyle', '')
  },
/*ページ移動の際、イベントリスナー 登録要素を削除する*/
  beforeRouteLeave(to, from, next) {
    this.activeFlg = false
    next();
  },
  methods: {
    setRecruit() {
			if(this.$store.getters.originListRecruit .length == 0 ) {
				/*データがない場合は、storeの状態を監視して、読み込み終了とともにセットする*/
				this.detailName = decodeURI(this.$route.path.match(/([^\/.]+)/g).pop())
				this.$store.watch(
					(state, getters) => getters.originListRecruit,
					(newValue, oldValue) => {
						this.originListRecruit = this.$store.getters.originListRecruit
					}
				)
			} else {
				this.originListRecruit = this.$store.getters.originListRecruit
			}
    },
/*
デレクティブscrollは、エレメント生成(mounted)前に呼ばれるため、
getBoundingClientRect()
は正確な値が取得できない。
生成後のフックを指定し他場合、
bind
inserted
update
componentUpdated
update以下では、生成時はmountイベントまでなためセットできない。
という状態。
とりあえず、差分調整で対応する。

エレメント主体（directive）でなく、フック主体でセットに行けば問題ないはずだが。
*/
/*
    handleScroll(evt, el) {
			let aAdjust = 714 //差分調整
      let res = false
//表示開始は画面1/5から
      let adjustment = window.innerHeight

// 以下で取得されるrect.topの値が、実際のレイアウト状態の値に等しくないため別の方法で行う
      const rect = el.getBoundingClientRect()
			let aOffsetTop = rect.top
			let aOffsetBottom = rect.bottom

      if(aOffsetTop < adjustment && 0 < aOffsetBottom) {
        if(el.classList.contains('fromLeft')) {
          el.classList.add('animeFromLeft');
        } else if(el.classList.contains('fromRight')) {
          el.classList.add('animeFromRight')
        } else if(el.classList.contains('fromBottom')) {
          el.classList.add('animeFromBottom')
        } else if(el.classList.contains('fromTop')) {
          el.classList.add('animeFromTop')
        }
        res = true
      }
      return res
    },
*/
	},
}
</script>

<style>
</style>